// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:wght@200;300;400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.design-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--color-white);
  min-height: 100vh;
  padding: 100px 0;
  font-family: Jost;
  position: relative;
  z-index: 1; }
  .design-section h6 {
    color: var(--color-primary) !important;
    margin: 0; }
  .design-section::after {
    content: "";
    height: 200px;
    width: 200px;
    border-right: 50%;
    border-radius: 50%;
    background: #d6fefe;
    top: 15%;
    left: -1%;
    position: absolute;
    animation: animone 10s linear infinite alternate;
    z-index: -1; }
  .design-section::before {
    content: "";
    height: 120px;
    width: 120px;
    border-right: 50%;
    border-radius: 50%;
    background: #ebeaea;
    bottom: 15%;
    right: -1%;
    position: absolute;
    animation: animtwo 12s linear infinite alternate;
    z-index: -1; }

@keyframes animone {
  0% {
    top: 15%;
    left: -1%; }
  100% {
    top: 50%;
    left: 90%; } }

@keyframes animtwo {
  0% {
    bottom: 5%;
    right: -1%; }
  100% {
    bottom: 80%;
    right: 90%; } }
  .design-section h3 {
    font-size: 48px;
    margin-bottom: 12px;
    color: var(--color-black) !important;
    text-align: center; }
  .design-section p {
    text-align: center; }

.design {
  display: flex;
  align-items: center;
  justify-content: center; }

.timeline {
  width: 100%;
  height: auto;
  max-width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  margin-top: 60px; }
  .timeline p {
    text-align: unset; }

.timeline-content {
  padding: 20px;
  background: transparent;
  border: 2px solid #ebebeb;
  border-radius: 12px;
  box-shadow: 0 2px 21px #e1e1e1;
  color: white;
  padding: 1.75rem;
  transition: 0.4s ease;
  overflow-wrap: break-word !important;
  margin: 1rem;
  margin-bottom: 20px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column; }

.timeline-component {
  margin: 0px 20px 20px 20px; }
  .timeline-component h3 {
    font-size: 28px;
    font-weight: 500;
    margin: 20px 0 6px;
    color: var(--color-primary) !important; }
  .timeline-component p {
    margin: 8px 0 0;
    color: grey !important;
    text-align: center; }
  @media (max-width: 767px) {
    .timeline-component {
      margin: 0 0 20px; } }

.timeline_image {
  height: 120px;
  width: 120px; }
  .timeline_image img {
    height: 100%;
    width: 100%;
    object-fit: contain; }

@media screen and (min-width: 768px) {
  .timeline {
    display: grid;
    grid-template-columns: 1fr 3px 1fr;
    column-gap: 12px; }
  .timeline-middle {
    position: relative;
    border: 2px dashed #cacaca;
    width: 3px;
    height: 100%; }
  .main-middle {
    opacity: 0; }
  .timeline-circle {
    position: absolute;
    top: 0;
    left: 50%;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-image: linear-gradient(45deg, darkcyan, cyan);
    transform: translateX(-50%); } }
`, "",{"version":3,"sources":["webpack://./src/component/Timeline/Timeline.scss"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EAEjB,kBAAkB;EAClB,UAAU,EAAA;EAXZ;IAaI,sCAAsC;IACtC,SAAS,EAAA;EAdb;IAiBI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAA8B;IAC9B,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,gDAAgD;IAChD,WAAW,EAAA;EA3Bf;IA8BI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAA8B;IAC9B,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,gDAAgD;IAChD,WAAW,EAAA;;AAEb;EACE;IACE,QAAQ;IACR,SAAS,EAAA;EAEX;IACE,QAAQ;IACR,SAAS,EAAA,EAAA;;AAGb;EACE;IACE,UAAU;IACV,UAAU,EAAA;EAEZ;IACE,WAAW;IACX,UAAU,EAAA,EAAA;EA3DhB;IA+DI,eAAe;IACf,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB,EAAA;EAlEtB;IAqEI,kBAAkB,EAAA;;AAItB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAA;EAPlB;IASI,iBAAiB,EAAA;;AAIrB;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB,EAAA;;AAGxB;EACE,0BAA0B,EAAA;EAD5B;IAGI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC,EAAA;EAN1C;IASI,eAAe;IACf,sBAAsB;IACtB,kBAAkB,EAAA;EAEpB;IAbF;MAcI,gBAAgB,EAAA,EAEnB;;AAED;EACE,aAAa;EACb,YAAY,EAAA;EAFd;IAII,YAAY;IACZ,WAAW;IACX,mBAAmB,EAAA;;AAKvB;EACE;IACE,aAAa;IACb,kCAAkC;IAClC,gBAAgB,EAAA;EAElB;IACE,kBAAkB;IAElB,0BAA0B;IAC1B,UAAU;IACV,YAAY,EAAA;EAEd;IACE,UAAU,EAAA;EAEZ;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wDAAwD;IAEhD,2BAA2B,EAAA,EACpC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Jost:wght@200;300;400&display=swap');\n.design-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--color-white);\n  min-height: 100vh;\n  padding: 100px 0;\n  font-family: Jost;\n  // border-bottom: 3px dashed;\n  position: relative;\n  z-index: 1;\n  h6 {\n    color: var(--color-primary) !important;\n    margin: 0;\n  }\n  &::after {\n    content: \"\";\n    height: 200px;\n    width: 200px;\n    border-right: 50%;\n    border-radius: 50%;\n    background: rgb(214, 254, 254);\n    top: 15%;\n    left: -1%;\n    position: absolute;\n    animation: animone 10s linear infinite alternate;\n    z-index: -1;\n  }\n  &::before {\n    content: \"\";\n    height: 120px;\n    width: 120px;\n    border-right: 50%;\n    border-radius: 50%;\n    background: rgb(235, 234, 234);\n    bottom: 15%;\n    right: -1%;\n    position: absolute;\n    animation: animtwo 12s linear infinite alternate;\n    z-index: -1;\n  }\n  @keyframes animone {\n    0% {\n      top: 15%;\n      left: -1%;\n    }\n    100% {\n      top: 50%;\n      left: 90%;\n    }\n  }\n  @keyframes animtwo {\n    0% {\n      bottom: 5%;\n      right: -1%;\n    }\n    100% {\n      bottom: 80%;\n      right: 90%;\n    }\n  }\n  h3 {\n    font-size: 48px;\n    margin-bottom: 12px;\n    color: var(--color-black) !important;\n    text-align: center;\n  }\n  p{\n    text-align: center;\n  }\n}\n\n.design {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.timeline {\n  width: 100%;\n  height: auto;\n  max-width: 90%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  margin-top: 60px;\n  p{\n    text-align: unset;\n  }\n}\n\n.timeline-content {\n  padding: 20px;\n  background: transparent;\n  border: 2px solid #ebebeb;\n  border-radius: 12px;\n  box-shadow: 0 2px 21px #e1e1e1;\n  color: white;\n  padding: 1.75rem;\n  transition: 0.4s ease;\n  overflow-wrap: break-word !important;\n  margin: 1rem;\n  margin-bottom: 20px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.timeline-component {\n  margin: 0px 20px 20px 20px;\n  h3 {\n    font-size: 28px;\n    font-weight: 500;\n    margin: 20px 0 6px;\n    color: var(--color-primary) !important;\n  }\n  p{\n    margin: 8px 0 0;\n    color: grey !important;\n    text-align: center;\n  }\n  @media (max-width: 767px) {\n    margin: 0 0 20px;\n  }\n}\n\n.timeline_image {\n  height: 120px;\n  width: 120px;\n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n}\n\n\n@media screen and (min-width: 768px) {\n  .timeline {\n    display: grid;\n    grid-template-columns: 1fr 3px 1fr;\n    column-gap: 12px;\n  }\n  .timeline-middle {\n    position: relative;\n    // background: #777;\n    border: 2px dashed #cacaca;\n    width: 3px;\n    height: 100%;\n  }\n  .main-middle {\n    opacity: 0;\n  }\n  .timeline-circle {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background-image: linear-gradient(45deg, darkcyan, cyan);\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
